var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.width},[_c('date-picker',{staticClass:"input input-data-nascimento",class:_vm.width,attrs:{"outlined":"","label":_vm.label,"single-line":"","validator":_vm.validator,"error-messages":_vm.errors.first(_vm.field),"name":_vm.field},model:{value:(_vm.value),callback:function ($$v) {_vm.value=$$v},expression:"value"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }